import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DataTable } from "@/components/molecules/tables/data-table";
import { useCustomers } from "@/features/customers/hooks/use-customers";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import {
  useClientLinks,
  useScopedClient,
} from "@/features/clients/hooks/use-scoped-client";
import { useReadOnly } from "@/features/utils/api-scope";
import { useTranslation } from "@/features/utils/i18n";
import { useCustomersColumns } from "../../customers/components/columns";

export function LastCustomers() {
  const { t } = useTranslation("dashboard");
  const { clientId } = useScopedClient();
  const links = useClientLinks();
  const readOnly = useReadOnly();
  const { data, isLoading } = useCustomers(clientId, {
    limit: 5,
    sort_by: "created_at",
    sort_order: "desc",
  });
  // Read only (the client's file in the platform back-office): without the row
  // actions, which edit and delete.
  const allColumns = useCustomersColumns();
  const columns = readOnly
    ? allColumns.filter((column) => column.id !== "actions")
    : allColumns;
  const contactsHref = links.contacts();

  const customers = data?.customers || [];

  return (
    <Card className="flex-1">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>{t("recentCustomers.title")}</CardTitle>
          {contactsHref && (
            <Link
              to={contactsHref}
              className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1"
            >
              {t("recentCustomers.viewAll")}
              <ArrowRight className="h-4 w-4" />
            </Link>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <DataTable
          variant="embedded"
          hidePagination
          columns={columns}
          data={customers}
          isLoading={isLoading}
          total={customers.length}
        />
      </CardContent>
    </Card>
  );
}
